import {
  DEFAULT_SECTION,
  isConsultationSection,
  legacyConsultationSection,
  type ConsultationSection,
} from '../consultations/consultation-sections.js';

/** Chemin de reprise d'une consultation ouverte. La recherche conserve `?mode=`. */
export function consultationTabPath(id: string, section: string, search: string): string {
  const safe = isConsultationSection(section)
    ? section
    : (legacyConsultationSection(section) ?? DEFAULT_SECTION);
  const base = `/consultations/${id}/${safe}`;
  const query = search.startsWith('?') ? search.slice(1) : search;
  return query.length > 0 ? `${base}?${query}` : base;
}

/** Section visible dans l'URL, si l'adresse est celle d'une consultation. */
export function consultationRoute(
  location: string,
): { id: string; section: ConsultationSection } | null {
  const path = location.split('?')[0] ?? '';
  const parts = path.split('/').filter((part) => part.length > 0);
  const id = parts[1];
  const section = parts[2];
  if (parts[0] !== 'consultations' || id === undefined || !isConsultationSection(section)) {
    return null;
  }
  return { id, section };
}
